import { COLORS } from "../../styles";

export default function MiniBar({ pct, color }) {
  return (
    <div style={{ height: 4, background: COLORS.surface, borderRadius: 4, marginTop: 6, overflow: "hidden" }}>
      <div style={{ height: "100%", width: `${Math.min(pct, 100)}%`, background: color, borderRadius: 4, transition: "width 1s ease" }} />
    </div>
  );
}
